import React from "react";
import { Subscribe } from "unstated";
import SrpContainer from "../containers/SrpContainer";

const NearbyLocations = ({ places }) => (
  <section className="no-srp-venues-location">
    <h3>Try these nearby locations</h3>
    <p>We have some great Venue spaces in these areas.</p>
    <ul>
      {places.map((p, i) => (
        <li key={i}>
          <a href={`/book-venue-${p.sg}`} className="ux-a">
            {p.t}
          </a>
        </li>
      ))}
    </ul>
  </section>
);

const NearbyLocationsContainer = () => (
  <Subscribe to={[SrpContainer]}>
    {({ state: { noResults } }) => (
      <NearbyLocations places={noResults.places} />
    )}
  </Subscribe>
);

export default NearbyLocationsContainer;
